import { FormSectionLangFieldMap } from '@/types'
import { FieldType, SupportedLanguage } from '@/enum'

export const FAMILY_DETAILS_DATA: FormSectionLangFieldMap = {
  [SupportedLanguage.English]: [
    {
      id: 'e46f517c-73e3-4082-b954-ba0eac29e486',
      label: "Father's Name",
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'Shivaji Verma',
      identifier: 'fathername',
    },
    {
      id: 'ca1cfb1e-9a62-44bb-981c-d2eec2b81216',
      label: "Father's Occupation",
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'Goldsmith',
      identifier: 'occupation',
    },
    {
      id: 'dbc61050-d17f-47e7-96b8-419314eacee0',
      label: "Mother's Name",
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'Usha Verma',
      identifier: 'mothername',
    },
    {
      id: 'daf2beb4-d1c9-4f81-a70f-f2795713aa94',
      label: "Mother's Occupation",
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'Housewife',
      identifier: 'occupation',
    },
    {
      id: 'ba6dda7a-9ef1-4294-a65d-d438eec8304c',
      label: 'Brother(s)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '2 / 1 Married',
      identifier: 'brothercount',
    },
    {
      id: '286643a3-fd32-44bb-a54c-1e3142d3ab25',
      label: 'Sister(s)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '3 / 0 Married',
      identifier: 'sistercount',
    },
  ],
  [SupportedLanguage.Hindi]: [
    {
      id: 'bd7f4f9a-62c4-4d4f-b8af-cd18327941f6',
      label: 'पिता का नाम',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'शिवाजी वर्मा',
      identifier: 'fathername',
    },
    {
      id: 'ccd7779a-4c3b-43a9-9063-199029bf2e02',
      label: 'पिता का व्यवसाय',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'सुनार',
      identifier: 'occupation',
    },
    {
      id: '17b2d4c2-4617-460a-921a-17c85e2fa78f',
      label: 'माँ का नाम',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'उषा वर्मा',
      identifier: 'mothername',
    },
    {
      id: 'df238c5a-d59f-4df4-86fb-e0a9a28df269',
      label: 'माँ का व्यवसाय',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'गृहिणी',
      identifier: 'occupation',
    },
    {
      id: 'a27d61ad-0a1f-491f-aa01-4f9fd5e93606',
      label: 'भाई',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '2 / 1 विवाहित',
      identifier: 'brothercount',
    },
    {
      id: 'c64524c9-c7b9-4132-afd2-fc95887bed8f',
      label: 'बहन',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '3 / 0 विवाहित',
      identifier: 'sistercount',
    },
  ],
  [SupportedLanguage.Marathi]: [
    {
      id: 'fb51829f-bba6-4b3c-9a71-4f365da810d8',
      label: 'वडिलांचे नाव',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'शिवाजी वर्मा',
      identifier: 'fathername',
    },
    {
      id: '9f2ff302-99e1-44eb-a6e5-8603fe348f29',
      label: 'वडिलांचा व्यवसाय',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'सोनार',
      identifier: 'occupation',
    },
    {
      id: '65286fdb-5a79-4ce2-a891-d96d86ab02ac',
      label: 'आईचे नाव',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'उषा वर्मा',
      identifier: 'mothername',
    },
    {
      id: 'd5e17247-97d6-420f-8268-fd3ce4a13566',
      label: 'आईचा व्यवसाय',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'गृहिणी',
      identifier: 'occupation',
    },
    {
      id: 'bc579866-e252-4887-9890-b33314307908',
      label: 'भाऊ',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '२ / १ विवाहित',
      identifier: 'brothercount',
    },
    {
      id: '82616b86-34cd-4749-b0ef-4915365d5406',
      label: 'बहीण',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '३ / ० विवाहित',
      identifier: 'sistercount',
    },
  ],
  [SupportedLanguage.Gujarati]: [
    {
      id: 'd30b87cb-7d33-4af1-b975-ef538bdb6553',
      label: 'પિતાનું નામ',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'શિવાજી વર્મા',
      identifier: 'fathername',
    },
    {
      id: '707e2d0b-e3ab-4e9a-9090-49a5046a08d9',
      label: 'પિતાનું વ્યવસાય',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'સોની',
      identifier: 'occupation',
    },
    {
      id: '2b3105d2-0a91-49ae-b5cf-3eb8fc8c8726',
      label: 'માતાનું નામ',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ઉષા વર્મા',
      identifier: 'mothername',
    },
    {
      id: 'f74ea9a8-c610-4ad0-b35d-56c6c68af2cf',
      label: 'માતાનું વ્યવસાય',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ગૃહિણી',
      identifier: 'occupation',
    },
    {
      id: 'e665e8fb-a2bc-490e-9ecf-8c84e1407cbb',
      label: 'ભાઈ(ઓ)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '2 / 1 લગ્નગ્રસ્ત',
      identifier: 'brothercount',
    },
    {
      id: '585ba1b1-ed6a-4247-af8b-5b31f8a3b32e',
      label: 'બહેન(ઓ)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '3 / 0 લગ્નગ્રસ્ત',
      identifier: 'sistercount',
    },
  ],
  [SupportedLanguage.Bengali]: [
    {
      id: 'fa37931f-0262-42f6-b4ed-77fc77dfc3fd',
      label: 'পিতার নাম',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'শিবাজী ভার্মা',
      identifier: 'fathername',
    },
    {
      id: '997ac7dc-c96e-43ce-ac41-f6de7e8bb650',
      label: 'পিতার পেশা',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'সোনা কাটা',
      identifier: 'occupation',
    },
    {
      id: '666300a8-e198-4f05-9dba-4515e8a72e61',
      label: 'মাতার নাম',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'উষা ভার্মা',
      identifier: 'mothername',
    },
    {
      id: '827a8b1f-3fd8-4b3d-a83d-c25da356e6b8',
      label: 'মাতার পেশা',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'গৃহিণী',
      identifier: 'occupation',
    },
    {
      id: '95f09d15-31bf-467a-9d0d-885816a9b2f4',
      label: 'ভাই(ব্রাদার)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '২ / ১ বিবাহিত',
      identifier: 'brothercount',
    },
    {
      id: '5633f90f-0330-46ba-8400-0c5b3f3a3a74',
      label: 'বোন(সিস্টার)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '৩ / ০ বিবাহিত',
      identifier: 'sistercount',
    },
  ],
  [SupportedLanguage.Telugu]: [
    {
      id: '38d7e2e2-31fb-426a-ac55-a95da9b802ba',
      label: 'తండ్రి పేరు',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'శివాజీ వర్మ',
      identifier: 'fathername',
    },
    {
      id: '2973d8f9-9a90-4fc6-ab0d-6218acb23515',
      label: 'తండ్రి వృత్తి',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'బంగారు వ్యాపారి',
      identifier: 'occupation',
    },
    {
      id: '03ddfbd9-ee43-438b-91e0-e36481374718',
      label: 'తల్లి పేరు',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ఉష వర్మ',
      identifier: 'mothername',
    },
    {
      id: 'e9052ada-fa51-4795-8fee-34f2a64aa496',
      label: 'తల్లి వృత్తి',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'గృహిణి',
      identifier: 'occupation',
    },
    {
      id: '67384b0b-5ab3-4519-a61d-1311db277cbe',
      label: 'సోదరుడు(లు)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '2 / 1 వివాహితులు',
      identifier: 'brothercount',
    },
    {
      id: '89a503f8-31bd-4126-a34b-374f4d32956a',
      label: 'సోదరి(లు)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '3 / 0 వివాహితులు',
      identifier: 'sistercount',
    },
  ],
  [SupportedLanguage.Kannada]: [
    {
      id: 'c6fefbb8-2045-46db-aec2-88ed9fda0d1b',
      label: 'ತಂದೆಯ ಹೆಸರು',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಶಿವಾಜಿ ವರ್ಮಾ',
      identifier: 'fathername',
    },
    {
      id: '78c18fee-fd05-434e-8a7e-b1f6fbc360dc',
      label: 'ತಂದೆಯ ಉದ್ಯೋಗ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಬಂಗಾರದ ಕಮ್ಮಾರ',
      identifier: 'occupation',
    },
    {
      id: 'ad42c74c-48aa-415b-973e-37612f4488c1',
      label: 'ತಾಯಿಯ ಹೆಸರು',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಉಷಾ ವರ್ಮಾ',
      identifier: 'mothername',
    },
    {
      id: '82c76a79-0c8d-4528-97d0-30080390804d',
      label: 'ತಾಯಿಯ ಉದ್ಯೋಗ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಗೃಹಿಣಿ',
      identifier: 'occupation',
    },
    {
      id: '86b6ce1f-8bae-4b93-a45c-1d11b7e8f68d',
      label: 'ಅಣ್ಣ / ತಮ್ಮ (ಗಳು)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '2 / 1 ವಿವಾಹಿತ',
      identifier: 'brothercount',
    },
    {
      id: '9e934a5e-3fc9-4304-a45d-9d1a809bc081',
      label: 'ಅಕ್ಕ / ತಂಗಿ (ಗಳು)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '3 / 0 ವಿವಾಹಿತ',
      identifier: 'sistercount',
    },
  ],
  [SupportedLanguage.Tamil]: [
    {
      id: '74ca3cc4-800c-4023-9f42-8a36a7ab7af1',
      label: 'அப்பாவின் பெயர்',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'சிவாஜி வர்மா',
      identifier: 'fathername',
    },
    {
      id: 'f016f013-26b5-4589-b20d-f66a7384a417',
      label: 'தந்தையின் தொழில்',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'தங்ககாரன்',
      identifier: 'occupation',
    },
    {
      id: '5298bfeb-e84d-4f6f-adbd-85252766127a',
      label: 'அம்மாவின் பெயர்',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'உஷா வர்மா',
      identifier: 'mothername',
    },
    {
      id: '0b5252e1-2ee3-4496-a180-f89494269618',
      label: 'தாயின் தொழில்',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'வீட்டுப்பெண்',
      identifier: 'occupation',
    },
    {
      id: 'e0b33591-c500-4a1c-8e3f-f2b72278f8c9',
      label: 'சகோதரர்(கள்)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '2 / 1 திருமணம் செய்தவர்கள்',
      identifier: 'brothercount',
    },
    {
      id: 'cdfad364-b133-4288-8e0b-b645cd9f0353',
      label: 'சகோதரி(கள்)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '3 / 0 திருமணம் செய்தவர்கள்',
      identifier: 'sistercount',
    },
  ],
  [SupportedLanguage.Odia]: [
    {
      id: 'b3233584-35e2-41ae-865b-a7ce2a8c33fa',
      label: 'ବାପାଙ୍କ ନାମ',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ଶିବାଜୀ ବର୍ମା',
      identifier: 'fathername',
    },
    {
      id: '2047aa61-148f-439f-8792-bd631b1f92d4',
      label: 'ବାପାଙ୍କ ପେଶା',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ସୁନାର',
      identifier: 'occupation',
    },
    {
      id: '5802aa4d-f0a1-4968-b237-3fdebbcd3a95',
      label: 'ମାଁଙ୍କ ନାମ',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ଉଷା ବର୍ମା',
      identifier: 'mothername',
    },
    {
      id: 'ca397b5d-d4b1-4268-b7b3-e4805572a0cc',
      label: 'ମାଁଙ୍କ ପେଶା',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ଗୃହିଣୀ',
      identifier: 'occupation',
    },
    {
      id: 'a9f04d54-cf53-4f3d-81b8-e04c79c03809',
      label: 'ଭାଇ(ମାନେ)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '2 / 1 ବିବାହିତ',
      identifier: 'brothercount',
    },
    {
      id: 'b62e6764-52e7-4669-928f-6b3b1787f732',
      label: 'ଭଉଣୀ(ମାନେ)',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '3 / 0 ବିବାହିତ',
      identifier: 'sistercount',
    },
  ],
  [SupportedLanguage.Malayalam]: [
    {
      id: '4bb8da9a-cfb2-4a9d-b1aa-707563205053',
      label: 'അച്ഛന്റെ പേര്',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'രാജേഷ് വർമ്മ',
      identifier: 'fathername',
    },
    {
      id: '4023e163-28d5-495a-bf0c-d6b31d41b6a0',
      label: 'അച്ഛന്റെ തൊഴിൽ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'സ്വർണ്ണപ്പണിക്കാരൻ',
      identifier: 'occupation',
    },
    {
      id: '58e5c204-3ce3-4a40-965e-25fe23fdd1d8',
      label: 'അമ്മയുടെ പേര്',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ഉഷ വർമ്മ',
      identifier: 'mothername',
    },
    {
      id: '7e56a324-88d0-4044-8679-501de2def71c',
      label: 'അമ്മയുടെ തൊഴിൽ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'വീട്ടമ്മ',
      identifier: 'occupation',
    },
    {
      id: '6209f5b3-5044-42de-92dd-fb4ef254cd9a',
      label: 'സഹോദരന്മാർ',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '2 / 1 വിവാഹിതർ',
      identifier: 'brothercount',
    },
    {
      id: '35686c91-2eea-42df-8248-42ce1f3320dc',
      label: 'സഹോദരിമാർ',
      value: undefined,
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '3 / 0 വിവാഹിതർ',
      identifier: 'sistercount',
    },
  ],
}
